import type { EntityOptions, Media, VideoContentObject } from 'models';
import { VideoDetailArchivedContent } from './video-detail-archived-content';
import { VideoDetailDraftContent } from './video-detail-draft-content';
import { VideoPublishContent } from './video-publish-content';

type P = {
  fullData?: Media;
  getPathToEntityDetail: (id: string, options: EntityOptions) => string;
  trailerData?: Media;
  videoContentObject: VideoContentObject;
};

// TODO: Maybe change in `Archived` and `Published` props `trailerData` and `fullData` to required
const VideoDetailContent = ({ fullData, getPathToEntityDetail, trailerData, videoContentObject }: P) => {
  switch (videoContentObject.video.status) {
    case 'archived':
      return (
        <VideoDetailArchivedContent
          fullData={fullData}
          trailerData={trailerData}
          videoContentObject={videoContentObject}
        />
      );
    case 'draft':
      return (
        <VideoDetailDraftContent
          fullData={fullData}
          trailerData={trailerData}
          videoContentObject={videoContentObject}
        />
      );
    case 'published':
      return (
        <VideoPublishContent
          fullData={fullData}
          getPathToEntityDetail={getPathToEntityDetail}
          videoContentObject={videoContentObject}
        />
      );
  }
};

export default VideoDetailContent;
